export default function getAccountId(state) {
  return state.auth?.account?.id;
}
